import {createReducer, on} from '@ngrx/store';
import * as ResearchKeywordActions from './research-keyword.actions';
import {ResearchKeywordDTO} from '../../dto/research-keywords';

export interface ResearchKeywordState {
  keywordsByProject: { [projectId: number]: ResearchKeywordDTO[] };
  selectedKeyword: ResearchKeywordDTO | null;
  error: any;
  loading: boolean;
  generateLoading: boolean;
}

export const initialState: ResearchKeywordState = {
  keywordsByProject: {},
  selectedKeyword: null,
  error: null,
  loading: false,
  generateLoading: false,
};

export const researchKeywordReducer = createReducer(
  initialState,
  on(ResearchKeywordActions.loadResearchKeywords, (state) => ({
    ...state,
    loading: true,
  })),
  on(ResearchKeywordActions.loadResearchKeywordsSuccess, (state, {keywords}) => {
    const projectId = keywords.length > 0 ? keywords[0].projectId : null;

    if (projectId === null) {
      return {...state, loading: false};
    }

    return {
      ...state,
      keywordsByProject: {
        ...state.keywordsByProject,
        [projectId]: keywords,
      },
      loading: false,
    };
  }),
  on(ResearchKeywordActions.loadResearchKeywordsFailure, (state, {error}) => ({
    ...state,
    error,
    loading: false,
  })),
  on(ResearchKeywordActions.createResearchKeywordSuccess, (state, {keyword}) => ({
    ...state,
    generateLoading: false,
    keywordsByProject: {
      ...state.keywordsByProject,
      [keyword.projectId]: [...(state.keywordsByProject[keyword.projectId] || []), keyword],
    },
  })),
  on(ResearchKeywordActions.generateResearchKeyword, (state, {projectId}) => ({
    ...state,
    generateLoading: true,
    keywordsByProject: {
      ...state.keywordsByProject,
      [projectId]: [],
    },
  })),
  on(ResearchKeywordActions.generateResearchKeywordSuccess, (state, {projectId, keywords}) => {
    return {
      ...state,
      generateLoading: false,
      keywordsByProject: {
        ...state.keywordsByProject,
        [projectId]: [...(state.keywordsByProject[projectId] || []), ...keywords],
      },
    };
  }),
  on(ResearchKeywordActions.generateResearchKeywordFailure, (state, {error}) => ({
    ...state,
    error,
    generateLoading: false,
  })),
  on(ResearchKeywordActions.deleteResearchKeyword,
    ResearchKeywordActions.updateResearchKeyword,
    ResearchKeywordActions.createResearchKeyword,
    (state, {}) => ({
      ...state,
      generateLoading: true,
    })),

  on(ResearchKeywordActions.deleteResearchKeywordSuccess, (state, {id}) => {
    const projectId = Object.keys(state.keywordsByProject).find((key) =>
      state.keywordsByProject[+key].some((keyword) => keyword.id === id)
    );

    if (!projectId) return state;

    return {
      ...state,
      generateLoading: false,
      keywordsByProject: {
        ...state.keywordsByProject,
        [projectId]: state.keywordsByProject[+projectId].filter((keyword) => keyword.id !== id),
      },
    };
  }),
  on(ResearchKeywordActions.retrieveResearchKeywordSuccess, (state, {keyword}) => ({
    ...state,
    selectedKeyword: keyword,
  })),
  on(ResearchKeywordActions.updateResearchKeywordSuccess, (state, {keyword}) => ({
    ...state,
    generateLoading: false,
    keywordsByProject: {
      ...state.keywordsByProject,
      [keyword.projectId]: state.keywordsByProject[keyword.projectId].map((k) =>
        k.id === keyword.id ? keyword : k
      ),
    },
  })),
  on(
    ResearchKeywordActions.loadResearchKeywordsFailure,
    ResearchKeywordActions.createResearchKeywordFailure,
    ResearchKeywordActions.deleteResearchKeywordFailure,
    ResearchKeywordActions.retrieveResearchKeywordFailure,
    ResearchKeywordActions.updateResearchKeywordFailure,
    (state, {error}) => ({
      ...state,
      generateLoading: false,
      error,
    })
  )
);
